//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import { server } from "@/services/constants";
import {
  getIncorporateMatterPagination,
  deleteIncorporateMatter,
} from "@/services/api-dtime/api_incorporate";

export default {
  name: "incorporate-matter-list",
  components: { SuccessDialog, SuccessDialogPush },
  data() {
    return {
      tableLoading: false,
      item_per_page_list: [10, 20, 100, 200, 500, 1000],
      page: 1,
      pageCount: 0,
      itemsPerPage: 100,
      totalItems: 0,
      mDataArray2: [],

      search: "",
      search_entity_type: "",
      search_status: "",

      entity_type_list: [
        { name: "Limited Company", value: "Limited Company" },
        { name: "Public Company Limited", value: "Public Company Limited" },
        { name: "Foundation", value: "Foundation" },
        { name: "Representative Office", value: "Representative Office" },
        { name: "Individual", value: "Individual" },
      ],
      status_list: [
        { name: "Active", value: "Active" },
        { name: "Inactive", value: "Inactive" },
      ],

      dialogDelete: false,
      dialogAdd: false,
      dialogAddPush: false,
      text_color: "text-h5 green--text text-center",
      title: "",
      message: "",
      link: "",
      id_del: 0,

      authorize_view: false,
      authorize_add: false,
      authorize_edit: false,
      authorize_del: false,
      authorize_id: "",
      userId: "",

      headers: [
        {
          text: "CLIENT NAME | ชื่อลูกค้า",
          value: "client_name",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
        {
          text: "ENTITY TYPE | ประเภทลูกค้า",
          value: "entity_type",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
        {
          text: "NATIONALITY | สัญชาติ",
          value: "nationality",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
        {
          text: "REGISTRATION NO. | เลขทะเบียน",
          value: "registration_no",
          class: "bg-colorth tabletextwhite",
          divider: true,
        },
        {
          text: "STATUS",
          value: "status",
          class: "bg-colorth tabletextwhite",
          align: "center",
          divider: true,
          width: "120px",
        },
        {
          text: "ACTION",
          value: "actions",
          class: "bg-colorth tabletextwhite",
          align: "center",
          sortable: false,
          divider: true,
          width: "90px",
        },
      ],
    };
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    this.$hideLoader();
    this.userId = localStorage.getItem(server.USER_ID);
    this.authorize_id = localStorage.getItem(server.AUTHORIZE_ID);

    if (!this.authorize_id || this.authorize_id == 0) {
      this.setupAlertDialog(
        true,
        "Authorize Failed",
        "Please Logout And Login Again",
        "text-h5 red--text text-center",
      );
      this.$router.back();
      return;
    }

    // Authorize check
    let parser = document.createElement("a");
    parser.href = window.location;
    const router_path = parser.pathname.replace("/", "");
    const { default: api } = await import("@/services/api");
    const res_auth = await api.getAuthorize(this.userId, router_path);
    this.authorize_view = res_auth.data[0].smd_view >= 1;
    this.authorize_add = res_auth.data[0].smd_add >= 1;
    this.authorize_edit = res_auth.data[0].smd_edit >= 1;
    this.authorize_del = res_auth.data[0].smd_del >= 1;

    if (!this.authorize_view) {
      this.$router.back();
      return;
    }

    await this.onSearchPagination();
  },
  methods: {
    getEntityTypeColor(type) {
      const map = {
        "Limited Company": "blue lighten-4",
        "Public Company Limited": "pink lighten-4",
        Foundation: "amber lighten-4",
        "Representative Office": "deep-purple lighten-4",
        Individual: "green lighten-4",
      };
      return map[type] || "grey lighten-3";
    },

    goToNewMatter() {
      this.$router.push("/incorporate-matter-entity-select");
    },

    viewItem(id) {
      this.$router.push(`/incorporate-matter-view/${id}`);
    },

    async loadDataByPage(pageNumber) {
      this.tableLoading = true;
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getIncorporateMatterPagination(
          pageNumber,
          this.itemsPerPage,
          "id",
          "DESC",
          company_id,
          this.search,
          this.search_entity_type,
          this.search_status,
        );
        this.mDataArray2 = res.data.data;
        this.totalItems = res.data.pagination.totalRecords;
        this.page = res.data.pagination.currentPage;
        this.pageCount = res.data.pagination.totalPages;
      } catch (error) {
        console.error("Error loading page:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถโหลดข้อมูลได้",
          "text-h5 red--text text-center",
        );
      } finally {
        this.tableLoading = false;
      }
    },

    async onSearchPagination() {
      this.page = 1;
      this.tableLoading = true;
      try {
        const company_id = localStorage.getItem(server.COMPANYID);
        const res = await getIncorporateMatterPagination(
          1,
          this.itemsPerPage,
          "id",
          "DESC",
          company_id,
          this.search,
          this.search_entity_type,
          this.search_status,
        );
        this.mDataArray2 = res.data.data;
        this.totalItems = res.data.pagination.totalRecords;
        this.pageCount = res.data.pagination.totalPages;
      } catch (error) {
        console.error("Error searching:", error);
        this.mDataArray2 = [];
        this.totalItems = 0;
        this.pageCount = 0;
      } finally {
        this.tableLoading = false;
      }
    },

    deleteItem(id) {
      this.id_del = id;
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      try {
        await deleteIncorporateMatter(this.id_del);
        this.setupAlertDialog(
          true,
          "Success",
          "ลบข้อมูลสำเร็จ",
          "text-h5 green--text text-center",
        );
        await this.onSearchPagination();
      } catch (error) {
        console.error("Error deleting:", error);
        this.setupAlertDialog(
          true,
          "Error",
          "ไม่สามารถลบข้อมูลได้",
          "text-h5 red--text text-center",
        );
      }
      this.closeDelete();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.id_del = 0;
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
  },
};
